import { CARREGAR_MAPA_POLYS_SERVER } from "../constants/constants";
import {database} from '../firebase'
import {carregarMapaNaStore} from '../actions/mapa'

export default ({dispatch}) => next => action =>{
    switch(action.type){
        case CARREGAR_MAPA_POLYS_SERVER:
            database.ref('/mapa/').on('value', (snap)=>{
                dispatch(carregarMapaNaStore(snap.val()));
            })
    }
    next(action);
}



// WEBPACK FOOTER //
// ./src/middlewares/carregarMapaPolys.js